import { registerPlugin } from '@capacitor/core';

export interface ClearCachePlugin {
    clearCache(): Promise<void>;
}

const ClearCache = registerPlugin<ClearCachePlugin>('ClearCache');

export default ClearCache;
